<template>
  <div>
    <Header></Header>
    <!-- <label class="verticalLabel left moduleTitle">ANNUAL REPORT 2020</label>
        <label class="verticalLabel right reportTitle">Diversity & Inclusion</label> -->
    <div class="diveristy-inclusion">
      <!-- Scroll Spy -->

      <sctionsScroll :page-sections="pageSections"></sctionsScroll>

      <!-- Scroll Spy -->
      <div id="introduction">
        <div class="section section_one">
          <div class="overlayTop"></div>
          <div class="container">
            <div class="innerSectio">
              <div class="innerText">
                <h1 v-html="this.data.title"></h1>
              </div>
            </div>
          </div>
          <div class="overlayBottom"></div>
        </div>
        <div class="section section_two">
          <div class="container">
            <div class="innertext_border_top">
              <div class="main_text">
                <p data-aos="fade-up" v-for="(text,index) in this.data.section2.contents" :key="'A' + index">
                  {{text}}
                </p>
                
                <ul>
                  <li data-aos="fade-up" v-for="(item,index2) in this.data.section2.list" :key="'B' + index2">
                    {{item}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="section section_three">
          <div class="container">
            <div class="innercontent image-reveal">
              <img
                :src="require(`@/assets/images/diversity-inclusion/${this.data.section3.image}`)"
                alt=""
                class="img-fluid"
              />
              <div class="revealer"></div>
            </div>
          </div>
        </div>
        <div class="section section_four">
          <div class="container">
            <div class="maintext">
              <div class="row align-items-end no-gutters">
                <div class="col-lg-5">
                  <div class="inner_left" data-aos="fade-right">
                    <div class="icons" >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 105 102"
                      >
                        <image
                          id="vision_icon"
                          data-name="vision icon"
                          xlink:href="data:img/png;base64,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"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="col-lg-7 ">
                  <div class="innerText_border_top">
                    <h4 data-aos="fade-up" v-html="this.data.section3.title">
                    </h4>
                    <ul>
                      <li data-aos="fade-up" v-for="(item,index3) in this.data.section3.list" :key="'C' + index3">
                        {{item}}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="we">
        <div class="section section_five">
          <div class="main_content">
            <div class="Section_parent p-relative">
              <div class="container">
                <div class="row upperContent">
                  <div class="col-lg-7 col-xxl-7">
                    <div class="">
                      <div class="innerText_border_top">
                        <span class="txt-outside" data-aos="fade-up">{{this.data.section4.title}}</span>
                        <p data-aos="fade-up" v-for="(text,i) in this.data.section4.contents" :key="'D' + i">
                          {{text}}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-xxl-5 image_section">
                    <div class="image-reveal" data-type="bottom">
                      <img
                        :src="require(`@/assets/images/diversity-inclusion/${this.data.section4.image}`)"
                        alt=""
                        class="img-fluid"
                      />
                      <div class="revealer"></div>
                    </div>
                  </div>
                </div>
                <div class="lowerContent">
                  <p data-aos="fade-up" class="lowerContent-text" v-for="(text,ii) in this.data.section4.contents2" :key="'E' + ii">
                    {{text}}
                  </p>
                  <ol >
                    <li data-aos="fade-up" v-for="(item,index5) in this.data.section4.list" :key="'F' + index5" v-html="item">
                      <!-- {{item}} -->
                    </li>
                  </ol>
                  <p data-aos="fade-up" v-for="(text,i2) in this.data.section4.contents3" :key="'F' + i2">
                    {{text}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section section_six">
          <div class="main_content">
            <div class="container">
              <div class="row col-gap-50 align-items-end">
                <div class="col-lg-6">
                  <div class="image ">
                    <div class="image-reveal" data-type="top">
                      <img
                        :src="require(`@/assets/images/diversity-inclusion/${this.data.section5.image}`)"
                        alt=""
                        class="img-fluid"
                      />
                      <div class="revealer"></div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="innerText_border_top">
                    <h4 data-aos="fade-up" v-html="this.data.section5.title"></h4>
                    <p data-aos="fade-up" v-for="(text,i3) in this.data.section5.contents" :key="'G' + i3">
                        {{text}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="we_able">
        <div class="section section_seven">
          <div class="main_content">
            <div class="container">
              <div class="image">
                <div class="image-reveal">
                  <img
                    :src="require(`@/assets/images/diversity-inclusion/${this.data.section6.image}`)"
                    alt=""
                    class="img-fluid"
                  />
                  <div class="revealer"></div>
                </div>
              </div>
              <div class="text-content">
                <div class="left-heading" data-aos="fade-up">{{this.data.section6.title}}</div>
                <div class="content">
                    <p class="mb-10" data-aos="fade-up" v-for="(text,i4) in this.data.section6.contents" :key="'HH' + i4">
                        {{text}}
                    </p>
                  <ol>
                    <li data-aos="fade-up" v-for="(item,index66) in this.data.section6.list" :key="'F' + index66">
                      {{item}}
                    </li>
                  </ol>
                <p data-aos="fade-up" v-for="(text,i4) in this.data.section6.contents2" :key="'H' + i4">
                    {{text}}
                </p>
                  <div class="image_border">
                    <div class="img_border image-reveal">
                      <img
                        :src="require(`@/assets/images/diversity-inclusion/${this.data.section6.image2}`)"
                        alt=""
                        class="img-fluid"
                      />
                      <div class="revealer"></div>
                    </div>
                    <div class="content">
                      <p data-aos="fade-up">
                        {{this.data.section6.imagetext}}
                      </p>
                    </div>
                  </div>
                  <p data-aos="fade-up" v-for="(text,i6) in this.data.section6.contents3" :key="'I' + i6">
                        {{text}}
                    </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- arsal updates  -->
      <div id="ZY">
        <div class="section section_last_four">
          <div class="container">
            <div class="image">
              <div class="image-reveal" data-type="slice">
                <img
                  :src="require(`@/assets/images/${this.data.section7.image}`)"
                  alt=""
                  class="img-fluid"
                />
                <div class="uncover">
                  <div class="uncover_slice"></div>
                  <div class="uncover_slice"></div>
                  <div class="uncover_slice"></div>
                </div>
              </div>
            </div>
            <div class="content">
            <div class="d-flex text-content">
              <div class="left-heading"><span class="txt-outside" data-aos="fade-up">{{this.data.section7.title}}</span></div>
              <div class="content">
                  <p data-aos="fade-up" v-for="(text,i7) in this.data.section7.contents" :key="'J' + i7">
                    {{text}}
                </p>
              </div>
            </div>
            </div>
            <div class="d-flex">
              <div>
                <div class="image">
                  <div class="image-reveal">
                    <img
                      :src="require(`@/assets/images/${this.data.section7.image2}`)"
                      alt=""
                      class="img-fluid"
                    />
                    <div class="revealer"></div>
                  </div>
                </div>
              </div>
              <div>
                <div class="image">
                  <div class="image-reveal">
                    <img
                      :src="require(`@/assets/images/${this.data.section7.image3}`)"
                      alt=""
                      class="img-fluid"
                    />
                    <div class="revealer"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container">
            <div class="row align-items-end">
              <div class="col-lg-6">
                <div class="image-in">
                  <div class="image-reveal " data-type="slice">
                    <img
                      :src="require(`@/assets/images/${this.data.section7.image4}`)"
                      alt=""
                      class="img-fluid"
                    />
                    <div class="uncover">
                      <div class="uncover_slice"></div>
                      <div class="uncover_slice"></div>
                      <div class="uncover_slice"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="max-content">
                  <p class="mb-0" data-aos="fade-up">
                    {{this.data.section7.p}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="Generation">
        <div class="section section_last_three">
          <div class="container">
            <h5 data-aos="fade-up">{{this.data.section8.title}}</h5>
            <div class="image">
              <div class="image-reveal">
                <img
                  :src="require(`@/assets/images/${this.data.section8.image}`)"
                  alt=""
                  class="img-fluid"
                />
                <div class="revealer"></div>
              </div>
            </div>
          </div>
          <div class="container">
            <p data-aos="fade-up" v-for="(text,i8) in this.data.section8.contents" :key="'K' + i8">
                    {{text}}
                </p>
            <div class="d-flex">
              <div>
                <div class="image">
                  <div class="image-reveal">
                    <img
                      :src="require(`@/assets/images/${this.data.section8.image2}`)"
                      alt=""
                      class="img-fluid"
                    />
                    <div class="revealer"></div>
                  </div>
                </div>
              </div>
              <div>
                <div class="image">
                  <div class="image-reveal">
                    <img
                      :src="require(`@/assets/images/${this.data.section8.image3}`)"
                      alt=""
                      class="img-fluid"
                    />
                    <div class="revealer"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="CODE">
        <div class="section section_last_two">
          <div class="container">
            <h5 data-aos="fade-up">{{this.data.section9.title}}</h5>
            <div class="d-flex justify-content-center">
              <div>
                <div class="image">
                  <div class="image-reveal" data-type="top">
                    <img
                      :src="require(`@/assets/images/${this.data.section9.image}`)"
                      alt=""
                      class="img-fluid"
                    />
                    <div class="revealer"></div>
                  </div>
                </div>
              </div>
              <div>
                <div class="image">
                  <div class="image-reveal" data-type="top">
                    <img
                      :src="require(`@/assets/images/${this.data.section9.image2}`)"
                      alt=""
                      class="img-fluid"
                    />
                    <div class="revealer"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container">
            
            <p data-aos="fade-up" v-for="(text,i9) in this.data.section9.contents" :key="'L' + i9">
                    {{text}}
                </p>
          </div>
        </div>
      </div>
      <div id="ZAINIAC">
        <div class="section section_last">
          <div class="container">
             <div class="left-heading" data-aos="fade-up">{{this.data.section10.title}}</div>
            <div class="image">
              <div class="image-reveal">
                <img
                  :src="require(`@/assets/images/${this.data.section10.image}`)"
                  alt=""
                  class="img-fluid"
                />
                <div class="revealer"></div>
              </div>
            </div>
            <div class="text-content">
             
              <div class="content">
                <p data-aos="fade-up" v-html="this.data.section10.contents.p">
                  <!-- {{this.data.section10.contents.p}} -->
                <!-- </p>
                <p data-aos="fade-up">
                  {{this.data.section10.contents.p[1]}}
                </p>
                <p data-aos="fade-up">
                  {{this.data.section10.contents.p[2]}}
                </p> -->
                <h5 data-aos="fade-up">{{this.data.section10.contents.title1}}</h5>
                <p data-aos="fade-up">
                  {{this.data.section10.contents.detail1}}
                </p>
                <h5 data-aos="fade-up">{{this.data.section10.contents.title2}}</h5>
                <p data-aos="fade-up" v-html="this.data.section10.contents.detail2">
                  <!-- {{this.data.section10.contents.detail2}} -->
                </p>
                <p data-aos="fade-up">
                  <!-- {{this.data.section10.contents.detail2[1]}} -->
                </p>
                <h5 data-aos="fade-up">{{this.data.section10.contents.title3}}</h5>
                <p data-aos="fade-up" v-html="this.data.section10.contents.detail3">
                  <!-- {{this.data.section10.contents.detail3}} -->
                </p>
                 <p data-aos="fade-up">
                  <!-- {{this.data.section10.contents.detail3[1]}} -->
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- arsal updates  -->
    </div>
  </div>
</template>

<script>

import { gsap } from "gsap";
import animation from "@/mixin/animation.js";
import util from '@/mixin/util';
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText);
import sctionsScroll from "@/components/common/sectionsScroll.vue";
import data from '@/components/data/diversity'; 

export default {
  mixins: [animation, util],
  components: {
    sctionsScroll,
  },
  data(){
      return{
          data:data,
          pageSections: [
        {
          title: "Introduction",
          title_ar: "مقدمة",
          id: "introduction", 
          number: "01",
        },
        {
          title: "WE ARE EQUAL",
          title_ar:  "برنامج WE",
          id: "we",
          number: "02",
        },
        {
          title: "we able",
          title_ar: " برنامج we able",
          id: "we_able",
          number: "03",
        },
        {
          title: "ZY",
          title_ar: "ZY",
          id: "ZY",
          number: "04",
        },
        {
          title: "Generation Z 2020",
          title_ar: "2020 Z جيل",
          id: "Generation",
          number: "05",
        },
        {
          title: "CODE 7 2021",
          title_ar: "CODE 7 2021",
          id: "CODE",
          number: "06",
        },
        {
          title: "ZAINIAC",
          title_ar: "منصة ZAINIAC",
          id: "ZAINIAC",
          number: "07",
        },
      ],
      }
  },

  mounted() {
    this.gsapAnimation();
    this.contentAnimation();
  },
  created(){
      if(this.$i18n.locale=="en"){
            this.data = data.en;
        }
        else{
            this.data = data.ar;   
        }
  },
  methods: {
    gsapAnimation() {
      gsap.set(".innerText", { autoAlpha: 1 });
      let split = new SplitText(".innerText h1", { type: "lines" });
      let tl = gsap.timeline();
      tl.fromTo(
        split.lines,
        { y: 200, autoAlpha: 0 },
        {
          autoAlpha: 1,
          y: 0,
          ease: "power4.Out",
          duration: 0.8,
          stagger: { from: "start", each: 0.5 },
        },
        "+=.5"
      );

      let overlay = gsap.timeline({ delay: 0.7 });
      overlay
        .fromTo(".overlayTop", { xPercent: 0 }, { xPercent: 12, duration: 1 })
        .fromTo(
          ".overlayBottom",
          { xPercent: 2 },
          { xPercent: -15, duration: 1 },
          0.0
        );

      let overlayRotateTop = gsap.timeline({
        scrollTrigger: {
          trigger: ".overlayTop ",
          start: "58% 40%",
          end: "+=" + window.innerHeight * 2,
          scrub: true,
        },
      });
      overlayRotateTop.to(".overlayTop", {
        xPercent: 15,
        y: -400,
        rotate: -40,
        ease:
          ("custom",
          "M0,0 C0.11,0.494 0.006,0.772 0.132,0.898 0.264,1.03 0.504,1 1,1 "),
      });

      let overlayRotateDown = gsap.timeline({
        scrollTrigger: {
          trigger: ".overlayBottom ",
          start: "25% 20%",
          end: "+=" + window.innerHeight * 2,
          scrub: true,
        },
      });
      overlayRotateDown.to(".overlayBottom", {
        xPercent: -55,
        y: 200,
        rotate: -40,
        ease:
          ("custom",
          "M0,0 C0.11,0.494 0.006,0.772 0.132,0.898 0.264,1.03 0.504,1 1,1 "),
      });
    },
  },
  
};
</script>
<style lang="scss" >
  [data-page="diversity-inclusion"]{
    .verticalLabel{
      color:#000;
    }
    .pageSections {
      .navbar{
        left:40px;
        @media screen and (max-width:1600px){
          left:22px;
        }
        .nav-item{
          a {
            margin:0 !important;
            span{
              background:rgba($color: #fff, $alpha: .5);
              padding-top:3px;
              padding-bottom:3px;
            }
          }
        }
      }
    }
    &.ar {
      .pageSections {
        .navbar{
          right:40px;
          left:auto;
          @media screen and (max-width:1600px){
            right:22px;
            left:auto;

          }
          .nav-item{
            a {
              span{
                background:rgba($color: #fff, $alpha: .5);
                padding-top:3px;
                padding-bottom:3px;
              }
            }
          }
        }
      }
    }
  }
</style>
<style lang="scss" scoped>
.diveristy-inclusion {
  background: url("../assets/images/diversity-inclusion/main_background.png");
  background-size: contain;
  background-repeat: repeat-y;
  overflow: hidden;
  .left-heading {
    font-size: rem(42px);
    color: #000000;
    text-transform: uppercase;
    line-height: 1.3;
    padding-bottom:rem(30px);
  }
  .container {
    @media screen and (max-width: 1300px) {
      padding-left: 45px;
    }
    @media screen and (max-width: 1199px) {
      padding-left: 80px;
    }
    @media screen and (max-width: 991px) {
      padding: 0 15px !important;
    }
  }
  // generic style

  @media (min-width: 1600px) {
    .col-xxl-7 {
      flex: 0 0 74%;
      max-width: 74%;
    }
    .col-xxl-5 {
      flex: 0 0 26%;
      max-width: 26%;
    }
  }
  .p-relative {
    position: relative;
  }
  p {
    font-size: rem(20px);
    color: #000000;
    margin-bottom: rem(30px);
    line-height: 1.4;
    &.lowerContent-text{
        @media screen and (min-width:1601px){
          max-width:900px;
        }
        // @media screen and (max-width:1600px) and (min-width:1400px){
        //   max-width:650px;
        // }
      }
  }
  ul,
  ol {
    margin-bottom: rem(30px);
    margin-left: rem(20px);
    li {
      font-size: rem(20px);
      color: #000000;
      line-height: 1.4;
    }
  }
  h5 {
    font-size: rem(30px);
    color: #000000;
    text-transform: uppercase;
    line-height: 1;
    margin-bottom: rem(30px);
  }
  .txt-outside {
    position: absolute;
    left: -80px;
    top: 0;
    font-size: rem(45px);
    color: #000000;
    text-transform: uppercase;
    line-height: 1;
    padding-right: 10px;
    @media screen and (max-width: 1400px) {
      position: static;
      margin-bottom: 30px;
      display: block;
    }
  }
  .innerText_border_top {
    padding-top: rem(50px);
    position: relative;
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      left: 0px;
      top: 0;
      height: 3px;
      background: #7d7d7d;
      opacity: 0.3;
    }
  }
  // generic style

  // Muddusar Changes
  h4 {
    font-size: rem(40px);
    color: #000000;
    text-transform: uppercase;
    line-height: 1;
    margin-bottom: rem(30px);
    @media screen and (max-width: 991px) {
      br {
        display: none;
      }
    }
  }
  .section {
    padding: rem(55px) 0;
    @media screen and (max-width: 1600px) {
      padding: rem(40px) 0;
    }
    @media screen and (max-width: 991px) {
      padding: rem(20px) 0;
    }
  }
  .section_one {
    min-height: 100vh;
    position: relative;
    overflow: hidden;
    .overlayTop {
      position: absolute;
      background-color: rgba(240, 240, 240, .4);
      top: -25%;
      left: -45%;
      width: 100%;
      height: 100%;
      transform: rotate(312deg);
      z-index: 1;
      @media screen and (max-width: 1199px) {
        top: -22%;
        left: -55%;
      }
       @media screen and (max-width: 991px) {
          top: -40%;
          left: -70%;
      }
      @media screen and (max-width: 767px) {
        display: none;
      }
    }
    .overlayBottom {
      position: absolute;
      background-color: rgba(240, 240, 240,.4);
      top: 35%;
      right: -40%;
      width: 100%;
      height: 100%;
      transform: rotate(312deg);
      @media screen and (max-width: 1199px) {
          top: 30%;
          right: -60%;
      }
       @media screen and (max-width: 991px) {
          top: 50%;
          right: -70%;
      }
      @media screen and (max-width: 767px) {
        display: none;
      }
    }
    .innerText {
      display: flex;
      min-height: calc(100vh - 3.4375rem * 2);
      align-items: center;
      // visibility: hidden;
      h1 {
        font-size: rem(70px);
        font-weight: lighter;
        margin: unset;
        width: max-content;
        padding: rem(50px) 0 0 0;
        position: relative;
        text-transform: uppercase;
        z-index: 2;
        span {
          font-weight: bold;
          font-weight: 900;
        }
        &::before {
          content: "";
          position: absolute;
          top: 0px;
          left: 0px;
          width: 60%;
          height: 3px;
          background: #7d7d7d;
          opacity: 0.3;
        }
        /deep/
      {
          font-size: rem(70px);
        font-weight: lighter;
        margin: unset;
        width: max-content;
        padding: rem(50px) 0 0 0;
        position: relative;
        text-transform: uppercase;
        z-index: 2;
        span {
          font-weight: bold;
          font-weight: 900;
        }
        
      }
      }
    }
    @media screen and (max-width: 1600px) {
      .innerText {
        h1 {
          font-size: rem(55px);
        }
      }
    }
    @media screen and (max-width: 1199px) {
      min-height: auto;
      .innerText {
        min-height: calc(70vh - 3.4375rem * 2);
        h1 {
          font-size: rem(45px);
        }
      }
    }
    @media screen and (max-width: 991px) {
      padding-top: rem(100px);
    }
    @media screen and (max-width: 575px) {
       .innerText {
        min-height: auto;
        padding:rem(40px) 0;
        h1 {
          font-size: rem(45px);
        }
      }
      .innerText {
        h1 {
          font-size: rem(40px);
          br {
            display: none;
          }
          span {
            display: block;
          }
        }
      }
    }
  }
  .section_two {
    padding-top: 0;
    .innertext_border_top {
      display: flex;
      min-height: calc(40vh - 3.4375rem * 2);
      align-items: center;
    }
  }
  .section_three {
    padding: unset;
    .innercontent {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .section_four {
    .inner_left {
      width: 100%;
      min-height: 350px;
      @media screen and (max-width:767px){
        min-height:250px;
      }
      // background: rgba(125, 125, 125, 0.1);
      position: relative;
      .icons {
        // width: 80px;
        // height: 80px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        svg {
          width: 155px;
          height: auto;
        }
      }
    }
    ul {
      // margin: unset;
      max-width: 500px;
    }
    @media screen and (max-width: 991px) {
      .inner_left {
        width: 90%;
        margin: rem(25px) auto rem(25px) auto;
      }
      ul {
        margin-left: rem(20px);
      }
    }
  }
  .section_five {
    .innerText_border_top {
      padding: rem(65px) 0 0 0;
      position: relative;
      @media screen and (max-width:1200px){
         padding: rem(40px) 0 0 0;
        }
      &::before {
        content: "";
        position: absolute;
        width: 100%;
        left: 0px;
        top: 0;
        height: 3px;
        background: #7d7d7d;
        opacity: 0.3;
        
        @media screen and (min-width:1200px){
          top: -25px;
        }
      }
    }
    .image_section {
      position: absolute;
      right: 0;
      padding: unset;
      top: -10px;
      @media screen and (max-width:991px){
          img{
            width:70%;
          }
        }
      .image {
        width: 500px;
        margin-right: 0;
        margin-left: auto;
      }
    }
    .txt-outside {
      // left: -100px;
      // top: 52px;
    }
    @media screen and (max-width: 1300px) {
      .image_section {
        top: 0;
        .image {
          width: 440px;
        }
      }
    }
    @media screen and (max-width: 1199px) {
      .upperContent {
        .col-lg-7 {
          padding-right: 30px;
        }
      }
    }
    @media screen and (max-width: 991px) {
      .image_section {
        position: static;
        .image {
          margin: rem(25px) auto rem(25px) auto;
        }
      }
    }
  }
  .section_seven {
    .image {
      margin-bottom: rem(50px);
    }
    .image_border {
      display: flex;
      align-items: center;
      margin-bottom: rem(50px);
      .img_border {
        max-width: 250px;
        flex: 0 0 250px;
        margin-right:rem(18px);
      }
      .content {
        p {
          margin: unset;
        }
      }
    }
    .text-content {
      display: flex;
      .left-heading {
        flex: 0 0 215px;
        font-size: rem(42px);
        color: #000000;
        text-transform: uppercase;
        line-height: 1;
      }
      .content {
        flex: 1;
      }
    }
    @media screen and (max-width: 991px) {
      .text-content {
        flex-direction: column;
        .left-heading {
          flex: none;
          padding-bottom: rem(20px);
        }
      }
      .image_border {
        .img_border {
          max-width: 250px;
          flex: 0 0 150px;
          padding-right: rem(20px);
        }
      }
    }
    @media screen and (max-width:575px){
      .image_border{
          flex-direction: column;
          align-items: center;
          .img_border{
            text-align: center;
            margin: auto;
            margin-bottom:rem(20px);
            flex: none;
            padding:0;
          }
      }
    }
  }
  // Muddusar changes
  // arsal css
  .container-md {
    max-width: 1080px;
    margin-left: auto;
    margin-right: auto;
  }
  .section_last_four {
    .content {
      position: relative;
    }
    .image {
      margin-bottom: rem(60px);
    }
    .d-flex {
      margin-top: rem(150px);
      margin-bottom: rem(130px);
      > div {
        &:not(:last-child) {
          margin-right: rem(12px);
        }
        .image {
          margin-bottom: rem(30px);
        }
      }
    }
    .max-content {
      max-width: 562px;
    }
    @media screen and (max-width: 991px) {
      .d-flex {
        margin-top: rem(90px);
        margin-bottom: rem(80px);
      }
      .image-in {
        max-width: 85%;
        margin: rem(25px) auto;
      }
      .max-content {
        max-width: 100%;
      }
    }
  }
  .section_last_three {
    .d-flex {
      > div {
        &:not(:last-child) {
          margin-right: rem(45px);
        }
        .image {
          margin-bottom: rem(30px);
        }
      }
    }
    .image {
      margin-bottom: rem(52px);
      text-align: center;
    }
  }
  .section_last_two {
    .d-flex {
      > div {
        &:not(:last-child) {
          margin-right: rem(45px);
        }
        .image {
          margin-bottom: rem(30px);
        }
      }
    }
    .image {
      margin-bottom: rem(45px);
      text-align: center;
      // img {
      //     height: 100%;
      // }
    }
  }
  .section_last {
    .image {
      margin-bottom: rem(50px);
    }
  }

  .text-content {
    display: flex;
    .left-heading {
      flex: 0 0 215px;
      font-size: rem(42px);
      color: #000000;
      text-transform: uppercase;
      line-height: 1.3;
    }
    .content {
      flex: 1;
    }
    @media screen and (max-width: 991px) {
      flex-direction: column;
      .left-heading {
        flex: none;
        padding-bottom: rem(20px);
        font-size: rem(35px);
      }
    }
  }
  // arsal css
}
/deep/{
  header .menu svg{
    fill: #000;
  }
  header .menu a{
    color: #000;
  }
  .verticalLabel{
    color:#000;
  }
}
#ZY{
    .left-heading{
    span{
        position: unset;
    }
}
}

[lang="ar"]{
  .diveristy-inclusion {
    .section_one {
      .innerText {
        h1{
          &:before{
            right:0;
            left:auto;
          }
        }
      }
    }
    ul, ol{
        margin-right: 1.25rem;
        margin-left:0;
    }
  .container {
    @media screen and (max-width: 1300px) {
      padding-right: 45px;
      padding-left:30px;
    }
    @media screen and (max-width: 1199px) {
      padding-right: 80px;
      padding-left:30px;
    }
  }
  // generic style



  .txt-outside {
    // right: -80px;
    left:auto;
    padding-left: 10px;
    padding-right:0;
  }

  .section_one {
    // .overlayTop {
    //   right: -45%;
    //   left:auto;
    //   @media screen and (max-width: 1199px) {
    //     right: -55%;
    //     left:auto;
    //   }
    //    @media screen and (max-width: 991px) {
    //       right: -70%;
    //       left:auto;
    //   }
    // }
    // .overlayBottom {
    //   left: -40%;
    //   right:auto;
    //   @media screen and (max-width: 1199px) {
    //       left: -60%;
    //       right:auto;
    //   }
    //    @media screen and (max-width: 991px) {
    //       left: -70%;
    //       right:auto;
    //   }
    // }
  }

  .section_four {


    @media screen and (max-width: 991px) {
      ul {
        margin-right: rem(20px);
        margin-left:0;
      }
    }
  }
  .section_five {

    .image_section {
      left: 0;
      right:auto;
      
      .image {
        margin-left: 0;
        margin-right: auto;
        
      }
    }
    // .txt-outside {
    //   right: -100px;
    //   left:auto;
    // }

    @media screen and (max-width: 1199px) {
      .upperContent {
        .col-lg-7 {
          padding-left: 30px;
          padding-right:15px;
        }
      }
    }
  }
  .section_seven {

    .image_border {
      .img_border {
        margin-left:rem(18px);
        margin-right:0;
      }
    }
    @media screen and (max-width: 991px) {

      .image_border {
        .img_border {
          padding-left: rem(20px);
          padding-right:0;
        }
      }
    }
  }
  // Muddusar changes
  // arsal css

  .section_last_four {
    .d-flex {
      > div {
        &:not(:last-child) {
          margin-left: rem(12px);
          margin-right:0;
        }
      }
    }

  }
  .section_last_three {
    .d-flex {
      > div {
        &:not(:last-child) {
          margin-left: rem(45px);
          margin-right:0;
        }
      }
    }
  }
  .section_last_two {
    .d-flex {
      > div {
        &:not(:last-child) {
          margin-left: rem(45px);
          margin-right:0;
        }
      }
    }
  }
  // arsal css
}
}
</style>
